<template>
    <div class="container">
        <div class="toolbar">
            <div class="left-items">
                <a-button class="item" icon="icon icon-home" @click="on_reset" />
                <a-button class="item" icon="icon icon-reset" @click="load" />
                <a-divider type="vertical" class="item" />

                <a-button class="item" icon="plus" @click="visible_verify = true" type="primary">发起实名认证</a-button>
                <!-- <a-divider type="vertical" class="item" /> -->
            </div>

            <div class="right-items"></div>
        </div>

        <div class="main">
            <a-table
                :columns="columns"
                :dataSource="data_source"
                rowKey="id"
                :loading="loading"
                :pagination="pagination"
                @change="on_pagination_change"
                :row-selection="{ selectedRowKeys: selected_row_keys, onChange: on_selection_change }"
                size="middle"
                :scroll="{ x: true }"
            >
                <!-- 操作 -->
                <template slot="action" slot-scope="text, record">
                    <div class="action">
                        <a-button size="small" style="margin-right:8px;" @click="on_update_verify(record)">更新状态</a-button>
                        <a-button size="small" @click="on_renew(record)">重新认证</a-button>
                    </div>
                </template>

                <template slot="verify_url" slot-scope="text, record">
                    <a disabled v-if="record.status == 2">已完成认证</a>
                    <a @click="do_copy(text)" v-else>点击复制链接</a>
                </template>

                <template slot="status" slot-scope="text">
                    <a-tag class="tag" v-if="text == 0">等待认证</a-tag>
                    <a-tag class="tag" color="blue" v-if="text == 1">认证中</a-tag>
                    <a-tag class="tag" color="green" v-if="text == 2">认证成功</a-tag>
                    <a-tag class="tag" color="red" v-if="text == -1">认证失败</a-tag>
                </template>
            </a-table>
        </div>

        <!-- 修改 -->
        <modal_verify :visible="visible_verify" @close="visible_verify = false" :record="selected_record" :callback="load" />

        <!-- 重新认证 -->
        <modal_renew
            :visible="visible_renew"
            @close="visible_renew = false"
            :member_id="selected_record ? selected_record.member_id : null"
            :callback="load"
        />
    </div>
</template>

<script>
    import moment from "moment";
    import common_pagination from "../../../mixins/common_pagination.js";
    import modal_verify from "../components/modal_verify.vue";
    import modal_renew from "../components/modal_renew";

    export default {
        mixins: [common_pagination],
        components: { modal_verify, modal_renew },
        data() {
            return {
                path: "/member/certification",
                data_source: [],
                loading: false,
                visible_verify: false,
                visible_renew: false,
                selected_record: null,
                wd: null,
                status: "",
                type: "",
                audit_status: null,
                columns: [
                    {
                        dataIndex: "status",
                        width: 100,
                        title: "认证状态",
                        scopedSlots: {
                            customRender: "status",
                        },
                    },
                    {
                        dataIndex: "customer_id",
                        title: "实名编号",
                    },
                    {
                        dataIndex: "member.name",
                        title: "客户姓名",
                    },
                    {
                        dataIndex: "member_id",
                        title: "客户ID",
                    },
                    {
                        dataIndex: "type",
                        title: "认证类型",
                        customRender: (e) => (e == 1 ? "个人" : "企业"),
                    },
                    {
                        dataIndex: "verified_at",
                        title: "认证时间",
                        customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
                    },
                    {
                        dataIndex: "verify_url",
                        title: "认证链接",
                        scopedSlots: {
                            customRender: "verify_url",
                        },
                    },
                    {
                        dataIndex: "user.name",
                        title: "发起者",
                        width: 100,
                    },
                    {
                        dataIndex: "created_at",
                        title: "发起时间",
                        width: 150,
                        customRender: (e) => (e ? moment(e * 1000).format("YYYY-MM-DD HH:mm") : ""),
                    },
                    {
                        dataIndex: "action",
                        width: 180,
                        align: "center",
                        title: "操作",
                        fixed: "right",
                        scopedSlots: {
                            customRender: "action",
                        },
                    },
                ],
            };
        },
        created() {
            this.load();
             this.$store.commit("change_state", {
                name: "member_sidebar_selected",
                value: "certification",
            });
        },
        watch: {
            $route() {
                this.load();
            },
        },
        methods: {
            moment,
            load() {
                this.loading = true;

                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                this.$http
                    .get(`/certification/verify?${this.objectToQuery(new_query)}`)
                    .then((res) => {
                        if (res.success) {
                            this.data_source = res.data;
                            this.pagination = {
                                pageSize: res.pagination.per_page,
                                total: res.pagination.total,
                                current: res.pagination.current_page,
                            };
                        }
                    })
                    .catch(() => {})
                    .then(() => {
                        this.loading = false;
                    });
            },
            on_field_change(e, field) {
                let new_query = JSON.parse(JSON.stringify(this.$route.query));
                new_query[field] = e.target.value;
                this.$router.push(this.path + "?" + this.objectToQuery(new_query));
            },
            on_renew(record) {
                this.selected_record = record;
                this.visible_renew = true;
            },
            on_update_verify(record) {
                this.$confirm({
                    centered: true,
                    title: "操作确认",
                    content: `是否需要查询并更新【${record.member.name}】的认证状态`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .post("/certification/verify/status", { member_id: record.member_id })
                                .then((res) => {
                                    if (res.success) {
                                        this.$success({
                                            title: "成功",
                                            centered: true,
                                            content: res.message,
                                        });
                                    } else {
                                        this.$error({ title: "失败", centered: true, content: res.message });
                                    }

                                    this.load();
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
            on_delete(record) {
                this.$confirm({
                    centered: true,
                    title: "删除确认",
                    content: `是否删除【${record.member.name}】的认证信息`,
                    loading: true,
                    onOk: () => {
                        return new Promise((resolve, reject) => {
                            this.$http
                                .delete("/certification/verify/" + record.member_id)
                                .then((res) => {
                                    if (res.success) {
                                        this.$message.success(res.message);
                                        this.load();
                                    } else {
                                        this.$error({ title: "失败", centered: true, content: res.message });
                                    }
                                })
                                .catch(() => {})
                                .then(() => {
                                    resolve();
                                });
                        }).catch();
                    },
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    .summary {
        padding: 16px;
        border-bottom: 1px solid #e8e8e8;
        box-sizing: border-box;
        display: flex;
        align-items: center;
    }
</style>
